// import { IThemeProps } from 'component/theme';
import styled from 'styled-components';
import DefaultUptimeTheme from "component/theme/defaultTheme";
import { COMMENT_INPUT_HEIGHT } from './constants';

export interface ICommentContainerProps {
  theme: typeof DefaultUptimeTheme;
  isMobile?: boolean;
}

export const StyledComments = styled.div`
  ${({ theme, isMobile }: ICommentContainerProps) => `
    .comments-wrap {
      .cmt-form {
        position: relative;
        box-shadow: none;
        background-color: transparent;
      }
      .inputBase {
        width: 100%;
        background: ${theme.uptimeColors.grayScales.white};
        border-radius: 24px;
        height: ${COMMENT_INPUT_HEIGHT}px;
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`};
        padding: ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[12]}px;
      }
      .MuiInputBase-root .MuiInputBase-input {
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
        padding-right: 64px;
        padding-left: ${theme.uptimeSpace[0]}px;
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      }
      .submit-btn {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: rotate(90deg) translateX(-50%);
        padding: ${theme.uptimeSpace[0]}px;
        &.submit-active-btn {
          .MuiSvgIcon-root {
            color: ${theme.uptimeColors.generalColors.icon.enabled};
          }
        }
      }
      .cmt-box{
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
      }
      .cmt-content > div {
        position: relative;
        margin-bottom: ${theme.uptimeSpace[4]}px;
      }
      .cmt-author-time {
        color: ${theme.uptimeColors.grayScales.darkerGray};
        margin: ${theme.uptimeSpace[0]}px;
      }
      .cmt-content-detail {
        word-wrap: break-word; 
        padding: ${theme.uptimeSpace[10]}px;
        color: ${theme.uptimeColors.textColors.primary};
        background-color: ${theme.uptimeColors.mainTheme.background};
        border-radius: ${theme.uptimeSpace[4]}px;
        & > *:not(h1):not(h2) {
          margin: 0;
        }
      }
      .cmt-author-name {
        color: ${theme.uptimeColors.textColors.primary};
      }
      .heading4 {
        font-size: ${theme.uptimeFontSizes.desktop.fz9}px;
        line-height: ${theme.uptimeLineHeights.desktop.lh7}px;
        color: ${theme.uptimeColors.textColors.primary};
        font-weight: 700;
        margin-bottom: ${theme.uptimeSpace[17]}px;
        padding-top: ${theme.uptimeSpace[8]}px;
        border-top: 1px solid ${theme.uptimeColors.grayScales.gray};
      }
      .heading5 {
        font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
        line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
        color: ${theme.uptimeColors.textColors.primary};
        font-weight: 600;
        margin: ${theme.uptimeSpace[0]}px;
      }
      .captionRegular {
        font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
        color: ${theme.uptimeColors.textColors.primary};
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
      }
      .cmt-status{
        padding-top: ${theme.uptimeSpace[16]}px;
        padding-bottom: ${theme.uptimeSpace[8]}px;
      }
      .cmt-body{
        padding-bottom: ${theme.uptimeSpace[12]}px;
      }
      .cmt-show{
        text-align: center;
        padding-bottom: ${theme.uptimeSpace[12]}px;
        button {
          color: ${theme.uptimeColors.generalColors.button.hyperlink.enabled};
          &:hover {
            color: ${theme.uptimeColors.generalColors.button.hyperlink.hover};
          }
        }
      }
      .bodyRegular,
      .bodyBold {
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        line-height: ${theme.uptimeLineHeights.desktop.lh5}px;
        color: ${theme.uptimeColors.textColors.primary};
      }
      .bodyBold {
        font-weight: 600;
      }
      .cmt-buttons {
        padding: 0 ${isMobile ? 0 : theme.uptimeSpace[5]}px;
        .MuiButton-root {
          font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
          text-transform: unset;
        }
        img,
        svg {
          width: 20px;
          margin: 0 ${theme.uptimeSpace[2]}px 0 0;
          color: ${theme.uptimeColors.generalColors.icon.enabled};
        }
        .buttonLink {
          min-width: ${isMobile ? 'unset' : ''};
        }
      }
      .buttonLink {
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
        font-weight: normal;
        font-family: '${theme.uptimeFonts.primary}'${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
        color: ${theme.uptimeColors.generalColors.icon.enabled};
        &.attachment {
          min-width: unset;
        }
      }
      .num-likes {
        svg {
          margin: 0 0 0 ${theme.uptimeSpace[2]}px;
        }
        display: flex;
        align-items: center;
      }
      .comment {
        padding: ${theme.uptimeSpace[10]}px 0 0;
      }
      .comment-nested {
        margin-left: ${theme.uptimeSpace[20] + 16}px;
      }
      .comment-level-no-indentation {
        .comment-nested {
          margin-left: ${theme.uptimeSpace[0]}px;
        }
      }
      .showMoreLink {
        color: ${theme.uptimeColors.mainTheme.primary};
        cursor: pointer;
      }
      .avatar-userlogin {
        width: 100% !important;
        height: 100% !important;
        color: ${theme.uptimeColors.generalColors.icon.enabled} !important;
        border: solid 1px ${theme.uptimeColors.generalColors.icon.enabled} !important;
        background-color: transparent !important;
        border-radius: 50%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .like-comment {
        color: ${theme.uptimeColors.generalColors.icon.enabled};
      }
      .comment-action {
        position: absolute;
        top: ${isMobile ? 'unset' : 0}px;
        bottom: ${isMobile ? -8 : 'unset'}px;
        right: ${isMobile ? 0 : 16}px;
        button {
          text-transform: capitalize;
        }
      }
      .comment-date {
        display: flex;
        margin: ${theme.uptimeSpace[4]}px 0 0;
        .edited-comment {
          margin-left: ${theme.uptimeSpace[8]}px;
          cursor: pointer;
        }
      }
    }
    `
  }
`;

interface StyledAvatarBlockProps {
  size: number;
  spacing: number;
}
export const StyledAvatarBlock = styled('div')<StyledAvatarBlockProps>(({ size, spacing }) => `
  overflow: hidden;
  margin-right: ${spacing}px;
  width: ${size}px;
  height: ${size}px;
  border-radius: 50%;
`);